<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="demand-forecast">
    <div
      class="vx-row"
      v-if="['SDF'].includes(artefact.type) && topUnits[type].seriesData &&  topUnits[type].seriesData.length > 0"
    >

      <!-- <div class="vx-col w-full mb-base">
        <vx-card title="Sale Trend &amp; Opportunity" subtitle="Actual and Forecast Sale by Week">
          <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts
              type="line"
              height="355"
              :options="topUnits[type].chartOptions"
              :series="topUnits[type].seriesData"
            />
          </div>
        </vx-card>
      </div> -->

      <!-- LINE CHART -->
      <div class="vx-col w-full mb-base">
        <vx-card title="Top categories - Forecast Demand"
          subtitle
        >
          <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts
              type="bar"
              height="310"
              :options="topUnits[type].chartOptions"
              :series="topUnits[type].seriesData"
            ></vue-apex-charts>
          </div>
        </vx-card>
      </div>

      <!-- TOP 5 CHART -->
      <!-- <div class="vx-col w-full md:w-1/3 mb-base">
        <vx-card :title="(artefact.type === 'SFM' ? 'Top Selling SKUs' : 'Slow Moving SKUs')" subtitle>
            <div slot="no-body" class="p-6 pb-10">
              <vue-apex-charts type="donut" height="325" :options="topUnits.sku.chartOptions" :series="topUnits.sku.seriesData"></vue-apex-charts>
            </div>
        </vx-card>
      </div>-->
    </div>
    <div
      class="vx-row"
      v-if="['SPO'].includes(artefact.type)"
    >
      <!-- LINE CHART -->
      <div class="vx-col w-full mb-base">
        <vx-card title="Sale Trend &amp; Opportunity" subtitle="Actual and Forecast Sale by Week">
          <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts
              type="line"
              height="355"
              :options="chart.chartOptions"
              :series="chart.series"
            />
          </div>
        </vx-card>
      </div>

      <!-- RADIAL CHART -->
      <!-- <div class="vx-col w-full md:w-1/3 mb-base"></div> -->
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VueApexCharts from "vue-apexcharts";

import appConfig from "@/../appConfig.js";
import { appCommons } from "@/app/shared/services";
import {fetchDummy} from "../shared/services";

const themeColors = appConfig.chart.colors;

export default {
  props: {
    artefact: { type: Object, required: true },
    type: { type: String, required: true }
  },
  components: {
    VueApexCharts,
    VuePerfectScrollbar,
  },
  data() {
    return {
      payload: {
        tags: [],
        dateRange: {},
        query: "",
        mode: "",
        type: "",
      },

      units: {
        category: {
          headers: [],
          data: []
        },
        sku: {
          headers: [],
          data: []
        }
      },
      topUnits: {
        count: 50,
        category: {
          label: "Categories",
          chartOptions: {},
          seriesData: []
        },
        sku: {
          label: "SKUs",
          chartOptions: {},
          seriesData: []
        }
      },
      trendDonut: {
        series: [],
        chartOptions: {
          labels: [],
          colors: themeColors,
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: "bottom"
                }
              }
            }
          ],
          legend: {
            show: false
          }
        }
      },
      trendBar: {
        series: [
          {
            name: "",
            data: []
          }
        ],
        chartOptions: {
          colors: themeColors,
          chart: {
            toolbar: {
              show: false
            },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: "rounded",
              columnWidth: "35%"
            }
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2]
          },
          xaxis: {
            labels: {
              show: false,
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            axisBorder: {
              show: false
            },
            title: {
              text: this.type === 'category' ? "Categories" : "SKUs",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            }
            // categories: []
          },
          yaxis: {
            title: {
              text: "Forecast "+this.artefact.mode === 'revenue' ? "Sales ( "+this.$options.filters.currencySymbol('')+" )" : "Quantity"
            }
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              // formatter: function(val) {
              //   return "$ " + val + " thousands"
              // }
            }
          }
        }
      },
      trendLine: {
        series: [
          {
            name: "",
            data: []
          }
        ],
        chartOptions: {
          chart: {
            type: "area",
            toolbar: { show: true },
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.2
            }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 8],
            width: [2, 2]
          },
          grid: {
            borderColor: "#e7e7e7"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            type: "datetime",
            tickAmount: 15,
            title: {
              text: "Week"
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ["Jan '18", "Feb '18", "Mar '18", "Apr '18", "May '18", "Jun '18", "Jul '18", "Aug '18", "Sep '18", "Oct '18", "Nov '18", "Dec '18", "Jan '19", "Feb '19", "Mar '19", "Apr '19", "May '19"],
            // categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May"],
            // categories: ["Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
            // categories:[],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            title: {
              text: this.artefact.mode === 'revenue' ? "Sales ( "+this.$options.filters.currencySymbol('')+" )" : "Quantity",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            },
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return val > 999
                  ? (val / 1000).toFixed(1) + "k"
                  : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
              }
            }
          },
          tooltip: {
            shared: true,
            intersect: false
            // x: { show: false }
          }
        }
      },
      trendLineChart: {
        series: [
          {
            name: "",
            data: []
          }
        ],
        chartOptions: {
          annotations: {
            xaxis: [
              {
                // in a datetime series, the x value should be a timestamp, just like it is generated below
                x: new Date("19 Apr 2020").getTime(),
                strokeDashArray: 0,
                borderColor: "#FEB019",
                label: {
                  borderColor: "#FEB019",
                  style: {
                    color: "#fff",
                    background: "#FEB019"
                  },
                  // text: "Demand"
                }
              },
              {
                x: new Date("12 Apr 2020").getTime(),
                // x2: new Date("19 Apr 2020").getTime(),
                borderColor: "#FEB019",
                fillColor: '#FEB019',
                label: {
                  borderColor: "#FEB019",
                  style: {
                    color: "#fff",
                    background: "#FEB019"
                  },
                  // orientation: "horizontal",
                  text: "Forecast Week"
                }
              }
            ],
            points: [
              {
                x: new Date("19 Apr 2020").getTime(),
                // y: 10000,
                marker: {
                  size: 6,
                  fillColor: "#fff",
                  strokeColor: "#2698FF",
                  radius: 2
                },
                label: {
                  borderColor: "#FF4560",
                  offsetY: 0,
                  style: {
                    color: "#fff",
                    background: "#FF4560"
                  },

                  // text: "Forecast Week...."
                }
              }
            ]
          },
          chart: {
            type: "area",
            toolbar: { show: true },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1
            }
          },
          stroke: {
            curve: "smooth",
            dashArray: [0, 4, 0, 4, 0, 4],
            width: [2, 2, 2, 2, 2, 2]
          },
          grid: {
            borderColor: "#e7e7e7"
          },
          legend: {
            show: false
          },
          colors: themeColors,
          fill: {
            type: "gradient",
            gradient: {
              shade: "dark",
              inverseColors: false,
              gradientToColors: themeColors,
              shadeIntensity: 1,
              type: "horizontal",
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100, 100, 100]
            }
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            type: "datetime",
            tickAmount: 15,
            title: {
              offsetY: 10,
              text: "Week"
            },
            labels: {
              hideOverlappingLabels: true,
              // datetimeFormatter: {
              //   year: 'yyyy',
              //   month: 'MMM \'yy',
              //   day: 'dd MMM',
              //   hour: 'HH:mm'
              // },
              style: {
                cssClass: "text-grey fill-current"
              }
            },
            axisTicks: {
              show: false
            },
            // categories: ["Jan '18", "Feb '18", "Mar '18", "Apr '18", "May '18", "Jun '18", "Jul '18", "Aug '18", "Sep '18", "Oct '18", "Nov '18", "Dec '18", "Jan '19", "Feb '19", "Mar '19", "Apr '19", "May '19"],
            // categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May"],
            // categories: ["Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan"],
            // categories:[],
            axisBorder: {
              show: false
            }
          },
          yaxis: {
            tickAmount: 5,
            title: {
              text: "Quantity",
              rotate: 90,
              offsetY: 0,
              offsetX: 0,
              style: { fontSize: "11px", cssClass: "" }
            },
            labels: {
              style: {
                cssClass: "text-grey fill-current"
              },
              formatter: function(val) {
                return (val > 999 || val < -999)
                  ? (val / 1000).toFixed(1) + "k"
                  : Math.round(val * Math.pow(10, 1)) / Math.pow(10, 1);
              }
            }
          },
          tooltip: {
            shared: true,
            intersect: false
            // x: { show: false }
          }
        }
      }
    }
  },
  computed: {
    // ...mapGetters({ items: "analyze/artefactUnit" })

    chart() {
      return this.buildStatsDataNew();
    }
  },
  methods: {
    fetchUnits(type, chartType) {
      this.units[type].data = this.formatItemsData(type);
      this.topUnits[type].chartOptions = this.chartOptions(type, chartType);
      this.topUnits[type].seriesData = this.seriesData(type, chartType);
    },
    formatItemsData(type) {
      let units = this.filterAndSortData(
        this.artefact.type,
        // this.items.res.order[type]
        this.artefact.res.demand[type]
      );
      return units.reverse();
    },
    filterAndSortData(rtype, data) {
      let filteredData = data.filter(t =>
        rtype === 'SDF'
      );

      return filteredData.sort(function(t1, t2) {
        var upd1 = t1.quantity;
        var upd2 = t2.quantity;

        if (upd1 < upd2) {
          return -1;
        }
        if (upd1 > upd2) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    },
    chartOptions(type, chartType) {
      // let unitsData = this.units[type].data.slice(0, this.topUnits.count);
      let unitsData = this.units[type].data;
      let typeData = [];

      for (let i = 0; i < unitsData.length; i++) {
        if(type === "sku") {
          typeData.push(unitsData[i].sku_id + ' - ' +unitsData[i].desc);
        } else if(!typeData.includes(unitsData[i].cat_1)) {
          typeData.push(unitsData[i].cat_1);
        }

        if(this.topUnits.count < typeData.length) break;
      }

      if (chartType === "bar") {
        this.trendBar.chartOptions.xaxis.categories = typeData;
        return this.trendBar.chartOptions;
      } else if (chartType === "donut") {
        this.trendDonut.chartOptions.labels = typeData;
        return this.trendDonut.chartOptions;
      }
    },
    seriesData(type, chartType) {
      let modeLabel = this.artefact.mode === 'revenue' ? "Sales ( "+this.$options.filters.currencySymbol('')+" )" : "Quantity";
      let unitsData = this.units[type].data.slice(0, this.topUnits.count);
      let seriesData = [
        {
          name: "Forecast by "+modeLabel,
          data: []
        }
      ];

      for (let i = 0; i < unitsData.length; i++) {
        if (chartType === "bar") {
          seriesData[0].data.push(Number(unitsData[i].quantity));
        } else if (chartType === "donut") {
          seriesData[0].data.push(Number(unitsData[i].quantity));
        }
      }

      return seriesData;
    },

    makeUnitStatsData() {
      let series = [];
      let chartData = {};
      chartData = Object.assign(chartData, this.trendLine);

      for (let i = 0; i < this.artefact.tags.length; i++) {
        if(this.artefact.type && this.artefact.type.startsWith(this.artefact.tags[i].type)) {
          let filteredUnitDataTrend = {
            name: "",
            data: []
          };

          filteredUnitDataTrend.name = this.artefact.tags[i].tag;

          let filterAndSortData = this.filterAndSortDataForLine(
            this.artefact.tags[i],
            this.artefact.res.demand
          );

          let groupedUnit = this.buildPlotData(
            filterAndSortData
          );

          // filteredUnitDataTrend.data = groupedUnit;

          let maxWeeks = filterAndSortData.length;

          filteredUnitDataTrend.data = this.buildseriesOfGroup(this.artefact.mode, maxWeeks, filterAndSortData);

          series.push(filteredUnitDataTrend);

          // chartData.xaxis.categories = this.buildCategoryData(filterAndSortData, 'sale_trend');
        }
      }

      chartData.series = series;
      // chartData.xaxis.categories = this.buildCategoryData(filterAndSortData, 'sale_trend');
      // return chartData;
      return series;
    },
    filterAndSortDataForLine(tag, data) {
      let filteredData = data.filter(t =>
        t.store_code
          ? tag.code === t.store_code
          : ((tag.tag === t.product_category) || (tag.tag === t.brand))
      );

      return filteredData.sort(function(t1, t2) {
        var year1 = t1.sale_year;
        var year2 = t2.sale_year;

        var week1 = t1.sale_week;
        var week2 = t2.sale_week;

        if (year1 < year2 && week1 < week2) {
          return -1;
        }
        if (year1 > year2 && week1 > week2) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    },
    buildPlotData(data) {
      let plot = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].type && data[i].type === "sale_trend") {
            plot.push(data[i].quantity);
          } else if (!data[i].type) {
            plot.push(data[i].quantity);
          }
        }
      }

      return plot;
    },
    buildCategoryData(data) {
      let plotCat = [];
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].type && data[i].type === "sale_trend") {
            plotCat.push(data[i].quantity);
          } else if (!data[i].type) {
            plotCat.push(data[i].quantity);
          }
        }
      }

      return plotCat;
    },

    buildseriesOfGroup(type, maxWeeks, groupedUnit) {
      let series = [];
      let weekIndex = 0;
      let currentWeek = Number(groupedUnit[0].sale_week || 1);
      let currentMonth = Number(groupedUnit[0].sale_month || 0) - 1;
      let currentYear = groupedUnit[0].sale_year.toString().slice(2);
      let prevWeek = 100;

      while (weekIndex < maxWeeks) {
        if (groupedUnit[weekIndex]) {
          currentWeek = Number(groupedUnit[weekIndex].sale_week || 1);
          currentMonth = Number(groupedUnit[weekIndex].sale_month || 0);
          currentYear = groupedUnit[weekIndex].sale_year.toString().slice(2);

          //   let x = "w" + currentWeek + (prevWeek > currentWeek ? " '" + currentYear : "");
          let x = this.$moment()
            .isoWeekYear(currentYear)
            .isoWeek(currentWeek+1)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + currentYear : "");
          let y = groupedUnit[weekIndex][type]
            ? groupedUnit[weekIndex][type] : 0;

          series.push({
            x: x,
            y: this.$options.filters.numFormat(y, '0.00')
          });
        } else {
          let x = this.$moment()
            .isoWeekYear(currentWeek === 1 ? ++currentYear : currentYear)
            .isoWeek(currentWeek+1)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + ++currentYear : "");
          let y = "0.00";

          currentWeek = currentWeek + 1;

          series.push({
            x: x,
            y: y
          });
        }

        prevWeek = currentWeek;
        weekIndex++;
      }
      return series;
    },
    showTitle() {

    },


    buildStatsData() {
      let series = [];
      let chartData = {};
      Object.assign(chartData, this.trendLineChart);

      for (let i = 0; i < this.artefact.tags.length; i++) {
        let filteredUnitDataTrend = {
          name: "",
          data: []
        };
        let filteredUnitDataPredict = {
          name: "",
          data: []
        };

        filteredUnitDataTrend.name = this.artefact.tags[i].tag + " - Sale";
        filteredUnitDataPredict.name = this.artefact.tags[i].tag + " - Predicted";

        let filteredActual = this.filterAndSortStatsData(
          this.artefact.tags[i],
          this.artefact.res.demand,
          "actual"
        );

        let filteredPredict = this.filterAndSortStatsData(
          this.artefact.tags[i],
          this.artefact.res.demand,
          "prediction"
        );

        let maxWeeksActual = filteredActual.length;
        let maxWeeksPredict = filteredPredict.length;
        if(maxWeeksActual > 0) {
          filteredUnitDataTrend.data = this.buildseriesOfStatsGroup("actual", maxWeeksActual, filteredActual, filteredActual[0].sale_year);
          series.push(filteredUnitDataTrend);
        }
        if(maxWeeksPredict > 0) {
          filteredUnitDataPredict.data = this.buildseriesOfStatsGroup("predict", maxWeeksPredict, filteredPredict, filteredPredict[0].sale_year);
          series.push(filteredUnitDataPredict);
        }
/*
        let predictionWeekStartDate = this.$moment()
            .isoWeekYear(filteredPredict[maxWeeksActual-1].sale_year)
            .isoWeek(filteredPredict[maxWeeksActual-1].sale_week)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

        let predictionWeekEndDate = this.$moment()
            .isoWeekYear(filteredPredict[maxWeeksPredict - 1].sale_year)
            .isoWeek(filteredPredict[maxWeeksPredict - 1].sale_week)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

        let predictionWeekStart = new Date(predictionWeekStartDate).getTime();
        let predictionWeekEnd = new Date(predictionWeekEndDate).getTime();

        this.trendLineChart.chartOptions = {
          ...this.trendLineChart.chartOptions,
          annotations: {
            ...this.trendLineChart.chartOptions.annotations,
            xaxis: [
              {
                // in a datetime series, the x value should be a timestamp, just like it is generated below
                // x: predictionWeekEnd,
                x: predictionWeekStart,
                borderColor: "#2698FF",
                fillColor: '#FEB019',
                label: {
                  borderColor: "#2698FF",
                  style: {
                    color: "#fff",
                    background: "#2698FF"
                  },
                  // orientation: "horizontal",
                  text: "Forecast Week"
                }
              }
            ],
            points: [
              {
                x: predictionWeekEnd,
                // y: 15000,
                marker: {
                  size: 6,
                  fillColor: "#fff",
                  strokeColor: "#2698FF",
                  radius: 2
                },
                label: {
                  borderColor: "#FF4560",
                  offsetY: 0,
                  style: {
                    color: "#fff",
                    background: "#FF4560"
                  }

                  // text: "Forecast Week"
                }
              }
            ]
          }
        };
*/
        // chartData.xaxis.categories = this.buildCategoryData(filterAndSortData, 'sale_trend');
      }

      this.trendLineChart.series = series;
      // chartData.series = series;
      // chartData.xaxis.categories = this.buildCategoryData(filterAndSortData, 'sale_trend');
      // return chartData;
      return this.trendLineChart;
    },
    filterAndSortStatsData(tag, data, type) {
      // let filteredData = data.filter(t =>
      //   ((t.store_code
      //     ? tag.code === t.store_code
      //     : tag.tag === t.product_category) && t.type === type)
      // );

      let filteredData = data.filter(t =>
        ((t.store_code
          ? tag.code === t.store_code
          : tag.tag === t.product_category) && (type !== 'prediction' ? (t.type === type) : true))
      );

      return filteredData.sort(function(t1, t2) {
        var year1 = t1.sale_year;
        var year2 = t2.sale_year;

        var week1 = t1.sale_week;
        var week2 = t2.sale_week;

        if (year1 < year2 && week1 < week2) {
          return -1;
        }
        if (year1 > year2 && week1 > week2) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    },

    buildseriesOfStatsGroup(type, maxWeeks, groupedUnit, startYear) {
      let series = [];
      let weekIndex = 0;
      let currentWeek = 1;
      let currentMonth = 0;
      let currentYear = startYear;
      let prevWeek = 100;

      while (weekIndex < maxWeeks) {
        if (groupedUnit[weekIndex]) {
          currentWeek = Number(groupedUnit[weekIndex].sale_week || 1);
          currentMonth = Number(groupedUnit[weekIndex].sale_month || 0);
          currentYear = groupedUnit[weekIndex].sale_year;

          //   let x = "w" + currentWeek + (prevWeek > currentWeek ? " '" + currentYear : "");
          let x = this.$moment()
            .isoWeekYear(currentYear)
            .isoWeek(currentWeek)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + currentYear : "");

          let fieldToFetch = type+'_qty';

          let y = groupedUnit[weekIndex].revenue
            ? groupedUnit[weekIndex].revenue || 0
            : groupedUnit[weekIndex][fieldToFetch] || 0;

          series.push({
            x: x,
            y: Math.floor(y)
          });
        } else {
          let x = this.$moment()
            .isoWeekYear(++currentYear)
            .isoWeek(currentWeek)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + ++currentYear : "");
          let y = "0";

          currentWeek = currentWeek + 1;

          series.push({
            x: x,
            y: y
          });
        }

        prevWeek = currentWeek;
        weekIndex++;
      }
      return series;
    },

    showTrend() {
      this.$vs.loading({
          // background: this.backgroundLoading,
          // color: this.colorLoading,
          // container: "#exploreButton",
          // scale: 0.45,
          type: "radius"
        });
      this.payload = {
        tags: this.artefact.tags,
        dateRange: this.dateScope(),
        query: this.artefact.query,
        mode: this.artefact.mode,
        type: 'SDT'
      };

      fetchDummy(this.payload)
        .then(response => {
          this.trendLineChart = this.buildStatsDataNew(response.data);
          this.$vs.loading.close();

        })
        .catch(error => {
          this.$vs.loading.close();
          throw new Error(error);
        });
    },
    dateScope() {
      let dateScope = appCommons.allowedDateScope(
        "",
        120,
        "minus"
      );

      this.allowedDateScope = dateScope;
      let dateRange = {
        startDate: dateScope.startDate,
        endDate: dateScope.endDate
      }

      return dateRange;
    },
    buildStatsDataNew(trendData) {
      let series = [];
      let chartData = {};
      Object.assign(chartData, this.trendLineChart);

      for (let i = 0; i < this.artefact.tags.length; i++) {
        let filteredUnitDataTrend = {
          name: "",
          data: []
        };
        let filteredUnitDataPredict = {
          name: "",
          data: []
        };

        filteredUnitDataTrend.name = "Actual Sale";
        filteredUnitDataPredict.name = "Predicted Sale";

        let filteredActual = this.filterAndSortStatsDataNew(
          this.artefact.tags[i],
          trendData,
          "actual"
        );

        let filteredPredict = this.filterAndSortStatsDataNew(
          this.artefact.tags[i],
          trendData,
          "prediction"
        );

        let maxWeeksActual = filteredActual.length;
        let maxWeeksPredict = filteredPredict.length;
        if(maxWeeksActual > 0) {
          filteredUnitDataTrend.data = this.buildseriesOfStatsGroupNew("actual", maxWeeksActual, filteredActual, filteredActual[0].sale_year);
          series.push(filteredUnitDataTrend);
        }
        if(maxWeeksPredict > 0) {
          filteredUnitDataPredict.data = this.buildseriesOfStatsGroupNew("predict", maxWeeksPredict, filteredPredict, filteredPredict[0].sale_year);
          series.push(filteredUnitDataPredict);
        }
/*
        let predictionWeekStartDate = this.$moment()
            .isoWeekYear(filteredPredict[maxWeeksActual-1].sale_year)
            .isoWeek(filteredPredict[maxWeeksActual-1].sale_week)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

        let predictionWeekEndDate = this.$moment()
            .isoWeekYear(filteredPredict[maxWeeksPredict - 1].sale_year)
            .isoWeek(filteredPredict[maxWeeksPredict - 1].sale_week)
            .startOf('isoWeek')
            .format('MM-DD-YYYY'); 
            
        let predictionWeekStart = new Date(predictionWeekStartDate).getTime();
        let predictionWeekEnd = new Date(predictionWeekEndDate).getTime();            

        this.trendLineChart.chartOptions = {
          ...this.trendLineChart.chartOptions,
          annotations: {
            ...this.trendLineChart.chartOptions.annotations,
            xaxis: [
              {
                // in a datetime series, the x value should be a timestamp, just like it is generated below
                // x: predictionWeekEnd,
                x: predictionWeekStart,
                borderColor: "#2698FF",
                fillColor: '#FEB019',
                label: {
                  borderColor: "#2698FF",
                  style: {
                    color: "#fff",
                    background: "#2698FF"
                  },
                  // orientation: "horizontal",
                  text: "Forecast Week"
                }
              }
            ],
            points: [
              {
                x: predictionWeekEnd,
                // y: 15000,
                marker: {
                  size: 6,
                  fillColor: "#fff",
                  strokeColor: "#2698FF",
                  radius: 2
                },
                label: {
                  borderColor: "#FF4560",
                  offsetY: 0,
                  style: {
                    color: "#fff",
                    background: "#FF4560"
                  }

                  // text: "Forecast Week"
                }
              }
            ]
          }
        };
*/
        // chartData.xaxis.categories = this.buildCategoryData(filterAndSortData, 'sale_trend');
      }

      this.trendLineChart.series = series;
      // chartData.series = series;
      // chartData.xaxis.categories = this.buildCategoryData(filterAndSortData, 'sale_trend');
      // return chartData;
      return this.trendLineChart;
    },
    filterAndSortStatsDataNew(tag, data, type) {
      // let filteredData = data.filter(t =>
      //   ((t.store_code
      //     ? tag.code === t.store_code
      //     : tag.tag === t.product_category) && t.type === type)
      // );

      let filteredData = data.filter(t =>
        ((t.store_code
          ? tag.code === t.store_code
          : tag.tag === t.product_category) && (type !== 'prediction' ? (t.type === type) : true))
      );

      return filteredData.sort(function(t1, t2) {
        var year1 = t1.sale_year;
        var year2 = t2.sale_year;

        var week1 = t1.sale_week;
        var week2 = t2.sale_week;

        if (year1 < year2 && week1 < week2) {
          return -1;
        }
        if (year1 > year2 && week1 > week2) {
          return 1;
        }

        // tags must be equal
        return 0;
      });
    },

    buildseriesOfStatsGroupNew(type, maxWeeks, groupedUnit, startYear) {
      let series = [];
      let weekIndex = 0;
      let currentWeek = 1;
      let currentMonth = 0;
      let currentYear = startYear;
      let prevWeek = 100;

      while (weekIndex < maxWeeks) {
        if (groupedUnit[weekIndex]) {
          currentWeek = Number(groupedUnit[weekIndex].sale_week || 1);
          currentMonth = Number(groupedUnit[weekIndex].sale_month || 0);
          currentYear = groupedUnit[weekIndex].sale_year;

          //   let x = "w" + currentWeek + (prevWeek > currentWeek ? " '" + currentYear : "");
          let x = this.$moment()
            .isoWeekYear(currentYear)
            .isoWeek(currentWeek)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + currentYear : "");

          let fieldToFetch = type+'_qty';

          let y = groupedUnit[weekIndex].revenue
            ? groupedUnit[weekIndex].revenue || 0
            : groupedUnit[weekIndex][fieldToFetch] || 0;

          series.push({
            x: x,
            y: Math.floor(y)
          });
        } else {
          let x = this.$moment()
            .isoWeekYear(++currentYear)
            .isoWeek(currentWeek)
            .startOf('isoWeek')
            .format('MM-DD-YYYY');

          // let x =
          //   "w" +
          //   currentWeek +
          //   (prevWeek > currentWeek ? " '" + ++currentYear : "");
          let y = "0";

          currentWeek = currentWeek + 1;

          series.push({
            x: x,
            y: y
          });
        }

        prevWeek = currentWeek;
        weekIndex++;
      }
      return series;
    },       
  },
  created() {},
  mounted() {
    if(['SDF'].includes(this.artefact.type)) {
      // this.showTrend();
      this.fetchUnits(this.type, "bar");
    } else if(['SPO'].includes(this.artefact.type)) {
      this.buildStatsData();
    }
  }
};
</script>

<style lang="scss">
#demand-forecast {
  .reportrange-text {
    background: transparent;
    cursor: pointer;
    padding: 0px;
    border: 0px;
  }
}
#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      // border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.chat-card-log {
  height: 400px;

  .chat-sent-msg {
    background-color: #f2f4f7 !important;
  }
}
</style>
